import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    padding: 10,
    marginTop: 25,
  },
}));

const Box = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.root} elevation={3} variant='outlined'>
      <Typography variant='h6' gutterBottom>
        {title}
      </Typography>
      <Divider />
      {children}
    </Paper>
  );
};

const FormBox = ({ children, title }) => <Box title={title}>{children}</Box>;

export default FormBox;
